import styled from 'styled-components';

export const StyledFormSection = styled.div`
  margin-bottom: 10px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  overflow: visible;

  .section-header {
    background-color: #f7f7f7;
    padding: 12px 16px;
    display: flex;
    align-items: center;
    gap: 8px;
    border-bottom: 1px solid #e0e0e0;

    i.icon {
      margin: 0;
      color: ${props => props.theme.firstColor} !important;
      font-size: 16px;
    }

    .section-title {
      font-weight: 600;
      font-size: 15px !important;
      color: ${props => props.theme.firstColor} !important;
    }
  }

  .section-content {
    padding: 10px 16px;
    background-color: #fff;
    overflow: visible;
  }
`
